<template>
  <div
    class="yxtbiz-ai-create-ques-ai"
    ref="talkArea"
    :class="{
      'yxtbiz-ai-create-ques-ai--mode1': this.askingType === 1,
      'yxtbiz-ai-create-ques-ai--mode2': this.askingType === 2
    }"
  >
    <!-- 先基于输入内容 提取知识点 -->
    <div class="yxtbiz-ai-create-ques__point-panel">
      <!-- 输入框 -->
      <ai-textarea
        ref="txtAsk"
        v-model="askInfo"
        maxlength="5000"
        :subDisabled="asking"
        @save="askAI(1, true)"
        :placeholder="
          $t(
            'pc_biz_ote_lbl_aigetpointstip' /** 输入或粘贴已有文档内容，AI将分析内容生成重要知识点 */
          )
        "
        :btnText="$t('pc_biz_ote_btn_getpoints' /** 提取知识点 */)"
        :canSave="!!selectedKngInfo"
        :subTip="selectedKngInfo && selectedKngInfo.title"
        :canBlur="!showSelectPanel || !!selectedKngInfo"
        :disabled="!hasAIBalances"
        @focus="inputing = true"
        @blur="inputing = false"
        @subFocus="changeSubInput(1)"
        @subBlur="changeSubInput(0)"
      >
        <!-- 输入状态下  选择文件按钮 -->
        <template slot="subinfo">
          <!-- 选择菜单 --> 
          <div 
            v-if="!selectedKngInfo" class="yxtbiz-ai-create-ques__select-file">
            <div class="color-gray-7 text-center mb8">{{ $t('pc_biz_ote_btn_selectkngtips')/** 你还可以选择文件生成知识点和试题 */ }}</div>
            <div class="flex flex-mid flex-center"> 
              <yxt-button type="text3" @click="startSelectKng()" class="yxtbiz-ai-create-ques__select-file-btn">
                <div class="flex flex-mid">
                  <yxt-svg
                    :remote-url="SvgMediaNewUrl"
                    width="20px"
                    height="20px"
                    icon-class="ai-kng-2"
                    class="color-gray-10"
                  ></yxt-svg>
                  <div class="ml4">
                    <div class="color-gray-10">
                      {{ $t('pc_biz_ote_btn_selectkng') /** 选择课程 */ }}
                    </div>
                  </div>
                </div>
              </yxt-button>
              <!-- <div class="yxtbiz-ai-create-ques__select-file-btn" @click="startSelectKngLib()"> -->
              <yxt-button type="text3" @click="startSelectKngLib()" class="yxtbiz-ai-create-ques__select-file-btn">
                <div class="flex flex-mid">
                  <yxt-svg
                    :remote-url="SvgMediaNewUrl"
                    width="20px"
                    height="20px"
                    icon-class="ai-kng-lib2"
                    class="color-gray-10"
                  ></yxt-svg>
                  <div class="ml4">
                    <div class="color-gray-10">
                      {{ $t('pc_biz_ote_btn_selectknglib') /** 选择知识 */ }}
                    </div> 
                  </div>
                </div>
              </yxt-button>
              <!-- <div @click="startUpload()" class="p12"></div> -->
            </div>
          </div>
          <!-- 已选择的课件、知识 -->
          <div v-else
            class="yxtbiz-ai-create-ques__selected-file"
          >
            <div class="flex flex-mid flex-shrink-1 yxtbiz-ote-ai-over-hidden">
              <yxt-svg
                class="flex-shrink-0 mr6"
                width="20px"
                height="20px"
                :remote-url="kngFileTypeIconUrl"
                :icon-class="getKngFileTypeIcon(selectedKngInfo.fileType)"
              />
              <yxt-tooltip :content="selectedKngInfo.title" open-filter placement="top">
                <div class="ellipsis mr4">{{ selectedKngInfo.title }}</div>
              </yxt-tooltip>
              <div v-if="selectedKngInfo.errorInfo" class="flex-shrink-0 flex flex-mid color-gray-7 ml12 yxtbiz-ai-create-ques__selected-file-error">
                <yxt-svg
                  @click.native="clearKngInfo"
                  class="mr4"
                  width="16px"
                  height="16px"
                  icon-class="message-error"
                />
                {{selectedKngInfo.errorInfo}}
              </div>
            </div>
            <div class="yxtbiz-ote-ai-icon ml8 hand" @click.stop="clearKngInfo">
              <yxt-svg width="16px" height="16px" icon-class="delete"></yxt-svg>
            </div>
          </div>
          <!-- 上传文件  暂不支持 -->
          <!-- <content-uploader
            v-if="false"
            ref="uploader"
            @uploaded="uploadedFile"
          /> -->
        </template>
        <!-- 输出考核点状态下 右上角操作区域 -->
        <template
          slot="contentSub"
          v-if="currentTalkPointInfo || (asking && askingType === 1)"
        >
          <template v-if="asking && askingType === 1">
            <yxt-button type="text3" @click="cancelAsk()">
              <span class="flex flex-mid"
                ><yxt-svg
                  :remote-url="SvgMediaNewUrl"
                  width="16px"
                  height="16px"
                  class="mr4"
                  icon-class="ai-stop-cc"
                ></yxt-svg>
                {{ $t('pc_biz_stop' /** 停止 */) }}
              </span>
            </yxt-button>
          </template>
          <template v-else>
            <!-- 历史切换 -->
            <div
              class="yxtbiz-ote-ai-icon color-gray-7"
              :class="{
                'yxtbiz-ote-ai-icon--disabled': askIndexHistoryIndex <= 0
              }"
            >
              <yxt-svg
                @click.native="changeAskIndexHistoryIndex(-1)"
                width="16px"
                height="16px"
                icon-class="arrow_left"
              ></yxt-svg>
            </div>
            <span class="mh4 minw24"
              >{{ askIndexHistoryIndex + 1 }}/{{
                currentAskPointsList.length
              }}</span
            >
            <div
              class="yxtbiz-ote-ai-icon color-gray-7"
              :class="{
                'yxtbiz-ote-ai-icon--disabled':
                  askIndexHistoryIndex >= currentAskPointsList.length - 1
              }"
            >
              <yxt-svg
                @click.native="changeAskIndexHistoryIndex(1)"
                width="16px"
                height="16px"
                icon-class="arrow_right"
              ></yxt-svg>
            </div>
          </template>
        </template>
        <!-- 输出考核点状态下中间考核点 -->
        <template slot="content" v-if="currentTalkPointInfo">
          <div ref="refPoints">
            <div class="mb12">
              {{
                $t(
                  'pc_biz_ote_lbl_aipointstip' /** 以下是为你提取的重要知识点，请根据需要选 */
                )
              }}
            </div>
            <yxt-checkbox-group
              v-model="currentTalkPointInfo.checkedPoints"
              direction="row"
            >
              <transition-group name="yxt-fade-in-linear" :key="currentTalkPointInfo.talkId">
                <yxt-checkbox
                  v-for="p in currentTalkPointInfo.allPoints"
                  :label="p.point"
                  :key="p.point"
                  >{{ p.point }}</yxt-checkbox
                >
              </transition-group>
            </yxt-checkbox-group>
            <div v-if="answering">
              <div class="flex">
                {{ $t('pc_biz_ai_thinking') /** 正在思考 */ }}
                <div class="ml8 yxtbiz-thinking-dot">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 输出考核点状态下处理中提示 -->
        <template slot="content" v-else-if="askingType === 1 && asking">
          <div
            class="flex flex-vertical flex-center flex-mid"
            v-if="parsing && selectedKngInfo"
          >
            <yxt-svg
              class="flex-shrink-0 mb8"
              width="40px"
              height="40px"
              :remote-url="kngFileTypeIconUrl"
              :icon-class="getKngFileTypeIcon(selectedKngInfo.fileType)"
            />
            <!-- 解析中，时间可能较长，请耐心等待 -->
            <div class="d-in-flex flex-mid mb20">
              <div
                v-loading="true"
                yxt-loading-custom-class="yxtbiz-ai-create-ques-loading"
                yxt-loading-size="small"
              ></div>
              <div class="color-gray-10">
                {{
                  $t(
                    'pc_biz_ote_msg_parsing' /** 解析中，时间可能较长，请耐心等待 */
                  )
                }}
              </div>
            </div>
            <yxt-button @click="cancelAsk()">{{
              $t('pc_biz_ote_btn_cancle') /** 取消 */
            }}</yxt-button>
          </div>
          <div v-else-if="answering">
            <div class="flex">
              {{ $t('pc_biz_ai_thinking') /** 正在思考 */ }}
              <div class="ml8 yxtbiz-thinking-dot">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div v-else></div>
        </template>
        <div class="color-gray-7 standard-size-12" v-if="currentTalkPointInfo && !asking" slot="contentBottomSub">
          {{$t('pc_biz_ote_msg_instructionsforaiquestip' /** 注：受限于AI模型，偶有AI返回的数据不完整，请自行核对生成的试题是否正确 */)}}
        </div>
        <!-- 输出考核点状态下 左下角选择按钮 -->
        <template slot="contentBottom" v-if="currentTalkPointInfo && !asking">
          <yxt-button type="text3" @click="askAI(1)">
            <span class="flex flex-mid"
              ><yxt-svg
                width="16px"
                height="16px"
                class="mr4"
                icon-class="right-rotate"
              ></yxt-svg>
              {{ $t('pc_biz_ai_reanswer' /** 重新回答 */) }}
            </span></yxt-button
          >
          <yxt-button type="text3" @click="backAsk(1)">
            <span class="flex flex-mid"
              ><yxt-svg
                width="16px"
                height="16px"
                class="mr4"
                icon-class="delete"
              ></yxt-svg>
              {{ $t('pc_biz_ote_btn_deprecate' /** 弃用 */) }}
            </span></yxt-button
          >
        </template>
      </ai-textarea>
      <!-- 出题设置 -->
      <div> 
        <!-- <div class="mt16 mb16 shrink1 flex over-hidden"> -->
          <!-- 选择题型 -->
          <!-- <type-selector-dropdown
            :title="$t('pc_biz_ote_btn_choosetopic')"
            :menus="quesTypeMenus"
            v-model="createQuesType"
            itemMinWidth="106px"
            class="mr16"
            large
          /> -->
          <!-- 生成数量 -->
          <!-- <type-selector-dropdown
            :title="$t('pc_biz_ote_btn_quesgencount')"
            class=""
            :menus="quesCountMenus"
            v-model="quesGenCount"
            large
            long
            itemCenter
            showTitle
          /> -->
        <!-- </div> -->
         <!-- 各题型出题数量 -->
        <div class="mt8 yxtbiz-ote-num-input-group">
          <number-input
            v-for="(c, type) in quesGenTypeCount"
            :key="type"
            :name="$t(QUES_TYPE_NAMES[type])"
            v-model="quesGenTypeCount[type]"
            :maxTip="$t('pc_biz_ote_msg_aiquesmaxcounttip' /** 每次最多生成10题 */,[10])"
            class="yxtbiz-ote-num-input"
          />
        </div>
        <div class="flex mt16"> 
          <yxt-tooltip
            :content="$t('pc_biz_ote_msg_viewaskedquestions'/** 查看已生成的试题 */)"
            placement="top"
            :disabled="asking || askingType === 2"
            v-if="beforeQuesTalkId"
          >
            <div
              class="yxtbiz-ai-talking__btns yxtbiz-ai-talking__btns--circle mr16 height40"
              @click="!asking && goAskedQues()"
              :class="{
                'yxtbiz-ai-talking__btns--disabled': asking
              }"
            >
              <yxt-svg
                width="24px"
                height="24px"
                icon-class="bars"
              ></yxt-svg>
            </div>
          </yxt-tooltip>
          <yxt-tooltip
            :content="$t(!hasAIBalances ? 'pc_biz_ote_msg_aiquesnobalancetip' /** 剩余可用出题题数不足，请联系管理员 */ : 'pc_biz_ote_msg_aiquesquitedittip'/** 请先退出内容修改或者点击生成知识点 */)"
            placement="top"
            :disabled="!askInfoEditing && hasAIBalances"
          >
            <yxt-button
              class="yxtbiz-ai-create-ques-btn flex-g-1"
              type="primary"
              size="large"
              @click="askAI(2)"
              :disabled="!isCanGenQues || !hasAIBalances || !hasGenQuesNum"
            >
              {{ $t('pc_biz_ote_btn_genques' /** 生成试题 */) }}
            </yxt-button> 
          </yxt-tooltip>
        </div>
        <div class="mt12 color-gray-7 standard-size-12 text-center">
          {{$t('pc_biz_ote_msg_tiptag',[$t('pc_biz_ote_msg_aiquescounttip' /** 注：每次最多生成10题，生成试题将消耗出题数量 */,[10])]) }}
        </div>
      </div>
      <!-- 选择课件、知识抽屉 -->
      <yxtbiz-select-kng
        ref="selectKng"
        :maxNum="1"
        :includeTypes="[1, 2, 3]"
        :openPage="openKngPage"
        :isOpenUpload="false"
        :IsBuyCourseMenu="false"
        :pmType="2"
        :isAi="true"
        :env="1"
        :zip="false"
        :isKngMenu="false"
        isCreateTime
        :excludeFileType="true"
        :isNoNeedAuth="false"
        :canSelectLibKng="false"
        :sourceType="1"
        :beforeKng="selectedKng ? [selectedKng] : []"
        @getKngInfo="getKngInfo"
        @closePage="closeKngPage"
      ></yxtbiz-select-kng>
      <yxt-drawer
        :title="$t('pc_biz_ote_btn_selectknglib') /** 选择知识 */"
        size="960px"
        :visible="openKngLibPage"
        destroy-on-close
        :before-close="closeKngLibPage"
      >
        <yxtbiz-select-newkng
          :max="1"
          :zip="false"
          :isAi="true"
          v-model="kngLibsTemp"
        >
        </yxtbiz-select-newkng>
        <div slot="footer">
          <yxt-button plain @click="closeKngLibPage">{{
            $t('pc_biz_ote_btn_cancle') /** 取消 */
          }}</yxt-button>
          <yxt-button type="primary" @click="getKngLibInfo">{{
            $t('pc_biz_ote_btn_confirm') /** 确定 */
          }}</yxt-button>
        </div>
      </yxt-drawer>
    </div>
    <!-- 再基于知识点 AI出题 -->
    <div class="yxtbiz-ai-create-ques__ques-panel">
      <div class="yxtbiz-ai-talking">
        <yxt-scrollbar :fit-height="true" ref="refTalk">
          <transition-group
            :key="'talkInfos_' + askingId"
            v-if="currentTalkInfo"
            tag="div"
            name="yxt-fade-in-linear"
            class="pt24 ph24 pb12"
          >
            <template v-for="(talk, index) in currentTalkInfo">
              <!-- AI回答 -->
              <div
                class="yxtbiz-ai-talking__dialog yxtbiz-ai-talking__dialog--noavatar"
                :key="talk.msg + '_answer_' + index"
                v-if="talk && (talk.msg || talk.allPoints) && talk.type === 12"
              >
                <div class="yxtbiz-ai-talking__dialog-avatar">
                  <yxt-svg
                    :remote-url="SvgMediaNewUrl"
                    width="28px"
                    height="28px"
                    icon-class="ai-avatar"
                  ></yxt-svg>
                </div>
                <div class="yxtbiz-ai-talking__dialog-content">
                  <div v-html="replaceTitlePrefix(talk.msg)"></div>
                  <div
                    class="mt16 flex flex-mid flex-between w-100"
                    v-if="talk.ques"
                  >
                    <yxt-button
                      type="text3"
                      class="yxtbiz-ai-talking__dialog-btn"
                      @click="useQues(talk)"
                      v-if="!talk.used"
                    >
                      <div class="flex flex-mid color-primary-6">
                        <yxt-svg
                          :remote-url="SvgMediaNewUrl"
                          width="16px"
                          height="16px"
                          class="mr4"
                          icon-class="ai-use-cc-s"
                        ></yxt-svg>
                        <span>{{
                          $t('pc_biz_ote_lbl_quote') /** 引用 */
                        }}</span>
                      </div>
                    </yxt-button>
                    <div v-else class="flex flex-mid">
                      <yxt-svg
                        width="16px"
                        height="16px"
                        class="mr4"
                        icon-class="message-success"
                      ></yxt-svg>
                      <span>{{
                        $t('pc_biz_ote_lbl_quoted') /** 已引用 */
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 思考中 -->
            <div
              key="ai-thinking"
              v-if="asking"
              class="yxtbiz-ai-talking__dialog yxtbiz-ai-talking__dialog--think yxtbiz-ai-talking__dialog--noavatar"
            >
              <div class="yxtbiz-ai-talking__dialog-avatar">
                <yxt-svg
                  :remote-url="SvgMediaNewUrl"
                  width="28px"
                  height="28px"
                  icon-class="ai-avatar"
                ></yxt-svg>
              </div>
              <div class="yxtbiz-ai-talking__dialog-content">
                <div class="flex">
                  {{ $t('pc_biz_ote_btn_thinking') /** 正在思考 */ }}
                  <div class="ml8 yxtbiz-thinking-dot">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt20 mb24 color-gray-7 standard-size-12"
              key="ai-result-tip"> 
              {{asking ? $t('pc_biz_ote_msg_tiptag',[$t('pc_biz_ote_msg_aiquesgentip' /** 注：在出题过程中关闭页面，也会进行相应题数的扣减，请避免在出题过程中关闭页面 */)])
                 : $t('pc_biz_ote_msg_instructionsforaiquestip' /** 注：受限于AI模型，偶有AI返回的数据不完整，请自行核对生成的试题是否正确 */)}}
            </div>
          </transition-group>
        </yxt-scrollbar>
      </div>
      <!-- 对话功能按钮 -->
      <div class="flex flex-center flex-mid pb24 pt12">
        <div class="yxtbiz-ai-talking__btns" @click="cancelAsk(true)" v-if="asking">
          <yxt-svg
            :remote-url="SvgMediaNewUrl"
            width="16px"
            height="16px"
            class="mr4"
            icon-class="ai-stop-cc"
          ></yxt-svg>
          {{ $t('pc_biz_ote_btn_stopgenerateques' /** 停止生成 */) }}
        </div>
        <div class="yxtbiz-ai-talking__btns" @click="askAI(2, false, true)" v-else>
          <yxt-svg
            :remote-url="SvgMediaNewUrl"
            width="16px"
            height="16px"
            class="mr4"
            icon-class="ai-continue1"
          ></yxt-svg>
          {{ $t('pc_biz_ote_btn_regenerateques' /** 重新生成 */) }}
        </div>
        <yxt-tooltip
          :content="$t('pc_biz_ote_msg_backtoeditpoints'/** 修改出题知识点或内容 */)"
          placement="top"
          v-if="!asking && askingType === 2"
        >
          <div
            class="yxtbiz-ai-talking__btns yxtbiz-ai-talking__btns--circle yxtbiz-ai-talking__btns--primary"
            @click="backAsk()"
          >
            <yxt-svg
              width="18px"
              height="18px"
              icon-class="edit"
            ></yxt-svg>
          </div>
        </yxt-tooltip>
      </div>
    </div>
  </div>
</template>
<script type='text/ecmascript-6'>
import {
  addResizeListener,
  removeResizeListener
} from 'yxt-biz-pc/src/utils/resize-event';

import { QUES_TYPE_NAMES, SvgMediaNewUrl } from '../const';
import { getGuid, dealLineFeed, cleanStyle } from '../utils';
import {
  analysisInputText,
  getAnalysedQuesList,
  // getAIQuesTypePrompt,
  getAIQuesPromptKeywords,
  loopApiCaller,
  replaceTitlePrefix,
  AIAskIdManager
} from '../utilsForAI';
import {
  getKngFileTypeIcon,
  kngFileTypeIconUrl
} from '../../../select-kng/src/utils';

import aiTextarea from '../components/aiTextarea.vue';
import typeSelectorDropdown from '../components/typeSelectorDropdown';
// import ContentUploader from './components/ContentUploader.vue';

import YxtbizSelectKng from '../../../select-kng';
import numberInput from '../components/numberInput.vue';
import YxtbizSelectNewkng from '../../../select-newkng';
import { generatePoint, generatePointStatus, generatePointStop } from '../ai.service';
import { generateQues, generateQuesDirect, generateQuesStatus, generateQuesStop } from '../ai.service';

export default {
  name: 'AiCreateQues',
  props: {
    libId: {
      type: String,
      default: ''
    },
    libName: {
      type: String,
      default: ''
    }
  },
  components: {
    aiTextarea,
    typeSelectorDropdown,
    YxtbizSelectKng,
    YxtbizSelectNewkng,
    numberInput
    // ContentUploader
  },
  data() {
    return {
      kngFileTypeIconUrl,
      pointsSupport: true,
      SvgMediaNewUrl,
      QUES_TYPE_NAMES,
      hasAIBalances: true,

      askIndex: -1, // 对话的批次
      askIndexHistoryIndex: 0, // 当前显示的对话批次中的对话的序号
      askInfo: '', // 出题范围
      askInfoEditing: false,
      askInfoTemp: '', // 出题范围，问答过程中暂存用
      askPointsTemp: '', // 出题知识点范围，问答过程中暂存用
      // quesGenCount: 5, // 试题生成数量
      quesGenTypeCount: [0, 0, 0, 0, 0],
      quesGenedCount: 0, // 已经生成的试题数量，后面如果是追加获取AI文本需要用到，不重复解析已经解析过的内容
      createQuesType: 0, // AI出题题型

      askingId: '', // 单次问答的识别号
      askingType: 1, // 0: 直接出题  1: 提取知识点 2：基于考核点出题
      requestClient: null,

      inputTxt: '', // AI出题，原题目对话文本
      startTxt: '', // 起始引导语
      talkIdList: [], // 对话历史 按单次id
      talkIndexList: [], // 对话历史 按批次
      talkInfos: {}, // 对话历史
      currentTalkId: '', // 当前对话的序号
      currentTalkPointInfo: null, // 当前提取的考核点对话内容
      beforeTalkPointInfo: null, // 上一次提取的考核点对话内容，取消时回退用
      beforeTalkInfo: null, // 上一次的对话内容
      beforeQuesTalkId: '', // 上一次对话出题的ID，用于切换回题目信息
      // 同内容查考核点缓存
      askPointsCache: {
        askPointsCount: 0, // 同内容查考核点次数
        askInfo: '',
        points: [],
        contentMap: {}
      },
      maxAskPointCount: 3, // 同内容查考核点最大次数

      simple: false, // 是否简略模式，不出考核点直接出题
      inputing: false, // 输入中
      asking: false, // 问答中
      parsing: false, // 问答是否还在解析中
      answering: false, // 问答是否还在回答中
      itvPoints: null,
      outPutItv: null,

      // 选择课件、知识
      kngLibsTemp: [],
      showSelectPanel: false,
      openKngPage: false,
      selectedKng: null,
      openKngLibPage: false,
      selectedKngLib: null,
      selectedFile: null,

      // 校验是否包含题目
      regexQT: new RegExp(
        `\\[${this.$t(QUES_TYPE_NAMES[0])}\\]|\\[${this.$t(
          QUES_TYPE_NAMES[1]
        )}\\]|\\[${this.$t(QUES_TYPE_NAMES[2])}\\]|${this.$t(
          QUES_TYPE_NAMES[3]
        )}\\]|\\[${this.$t(QUES_TYPE_NAMES[4])}\\]`
      )
    };
  },
  watch: {},
  created() {
    this.checkAIBalances();
  },
  computed: {
    selectedKngInfo() {
      return this.selectedKngLib || this.selectedKng;
    },
    userInfo() {
      return {
        userName: window.localStorage.username,
        userShortName: window.localStorage.fullname,
        headPictureUrl: window.localStorage.imgUrl
      };
    },
    currentTalkInfo() {
      // const talkId = this.talkIdList[this.talkIndex];
      return this.currentTalkId && this.talkInfos[this.currentTalkId];
    },
    currentAskPointsList() {
      return this.talkIndexList[this.askIndex]
        .filter(ask => {
          return ask[1] && ask[1].type === 13;
        })
        .map(ask => ask[1]);
    },
    // 出题数量菜单数据源
    quesCountMenus() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        .filter((e, i) => i < 10)
        .map(c => ({ id: c, name: c }));
    },
    // 出题类型菜单数据源
    quesTypeMenus() {
      const icons = [
        // 'compose',
        'singlechoice',
        'multiplechoice',
        'judgment',
        'fillin',
        'shortanswer'
      ];
      const menus = QUES_TYPE_NAMES.filter((e, i) => i < 5).map(
        (tn, index) => ({ id: index, name: this.$t(tn) })
      );
      // 暂时隐藏随机题型,prompt没有做全题型的
      // menus.unshift({ id: 100, name: this.$t('pc_biz_ote_lbl_randomques') });
      menus.forEach((m, index) => {
        m.icon = icons[index];
      });
      return menus;
    },
    isCanGenQues() {
      return !this.askInfoEditing && !this.asking && this.hasAIBalances &&
        (this.selectedKngInfo || this.askInfo.trim()) &&
        !(this.currentTalkPointInfo && this.currentTalkPointInfo.checkedPoints.length === 0) ;
    },
    hasGenQuesNum() {
      return !!this.quesGenTypeCount.find(num => num > 0);
    }
  },
  mounted() {
    addResizeListener(this.$refs.talkArea, this.setTalkOverLine);
  },
  methods: {
    replaceTitlePrefix,
    // 出题流程回退
    backAsk(clear) {
      if (this.askingType === 2) {
        if (this.currentTalkInfo && this.currentTalkInfo.length > 1) {
          this.beforeQuesTalkId = this.currentTalkId; // 出过题目 记录历史
        }

        this.askingType = 1;
        this.currentTalkId = (this.currentTalkPointInfo && this.currentTalkPointInfo.talkId) || -1;
        this.beforeTalkInfo = this.currentTalkId >= 0 ? this.talkInfos[this.currentTalkId] : undefined;
      } else {
        this.currentTalkId = '';
        this.currentTalkPointInfo = null;
        this.askingType = 1;

        // if (clear) {
        //   this.askInfo = '';
        //   this.selectedKng = null;
        //   this.selectedKngLib = null;
        // }
      }
    },
    // 切换到已经出的题目
    goAskedQues() {
      this.askingType = 2;
      this.currentTalkId = this.beforeQuesTalkId;
    },
    // 切换单批次内 考核点的提取历史
    changeAskIndexHistoryIndex(step) {
      const newIndex = this.askIndexHistoryIndex + step;
      if (this.currentAskPointsList[newIndex]) {
        this.askIndexHistoryIndex = newIndex;
        this.currentTalkPointInfo = this.currentAskPointsList[newIndex];
        // this.currentTalkPointInfo.checkedPoints = [];
        // this.currentTalkPointInfo.checkedPoints = this.currentTalkPointInfo.allPoints.map((p) => p.point);
      }
    },
    // 校验是否还有AI使用余额
    checkAIBalances() {
      // 暂时不提前校验
      this.hasAIBalances = true;
    },
    // 进行AI对话(后端包装)
    askAI(type = 1, resetAskIndex = false, reload = false) {
      if (this.asking) {
        return;
      }

      if (type === 2 && this.quesGenTypeCount.reduce((accumulator, currentValue) => accumulator + currentValue, 0) > 10) {
        this.$message({
          message: this.$t('pc_biz_ote_msg_aiquesmaxcounttip' /** 每次最多生成10题 */, [10]),
          type: 'info'
        });
        return;
      }

      this.asking = true;
      this.answering = false;
      this.parsing = false;

      if (resetAskIndex) {
        this.backAsk(); // 出题的时候如果修改内容出题，默认回到初始状态。
        this.askIndex++;
        this.askIndexHistoryIndex = 0;
      }

      this.beforeTalkInfo = this.currentTalkInfo;
      // 重置
      this.askingId = getGuid();
      this.askingType = type;

      // 请求体
      let requestBody = {
        sessionId: ''
      };
      if (reload && type === 2) {
        requestBody = this.oldQuesRequestBody;
        this.askInfoTemp = '';
        this.askPointsTemp = requestBody.pointContentBeanList;
      } else if (type === 2) {
        // 出题
        this.askInfoTemp = '';
        this.beforeQuesTalkId = '';
        this.resolvedTexts = undefined;
        this.askPointsTemp = this.currentTalkPointInfo && this.currentTalkPointInfo.allPoints.filter((p) =>
          this.currentTalkPointInfo.checkedPoints.includes(p.point)
        );

        if (!this.askPointsTemp || this.askPointsTemp.length === 0) {
          this.simple = true;
        } else {
          requestBody.pointContentBeanList = this.askPointsTemp;

          requestBody.contentMap = {};
          const askContentIds = [].concat(...this.askPointsTemp.map(pt => pt.contentIds));
          for (const p in this.currentTalkPointInfo.allContentMap) {
            if (askContentIds.includes(p)) {
              requestBody.contentMap[p] = this.currentTalkPointInfo.allContentMap[p];
            }
          }

          this.simple = false;
        }

        // requestBody.prompt = getAIQuesTypePrompt(this.createQuesType);
        requestBody.quesNum = 0;
        requestBody.quesReqInfoList = this.quesGenTypeCount.map((num, index) => {
          requestBody.quesNum += num;
          return {
            'quesType': index,
            'num': num
          };
        });
        requestBody.quesType = this.createQuesType;
        requestBody.promptKeyWords = getAIQuesPromptKeywords();

        this.oldQuesRequestBody = requestBody;
      }

      if (type === 1 || this.simple) {
        // 出考核点
        this.askInfoTemp = this.askInfo;
        requestBody.userInputContent = this.askInfoTemp;

        // 选择的知识信息
        if (this.selectedKngInfo) {
          Object.assign(requestBody, {
            fileId: this.selectedKngInfo.fileId,
            businessId: this.selectedKngInfo.id,
            kngName: this.selectedKngInfo.title,
            fileType: this.selectedKngInfo.fileType,
            kngType: this.selectedKngInfo.kngType === undefined ? this.selectedKngInfo.type : this.selectedKngInfo.kngType
          });
        }

        this.beforeTalkPointInfo = this.currentTalkPointInfo;
        this.currentTalkPointInfo = null;
      }

      // 初始化对话
      this.quesGenedCount = 0;
      this.questionsToTalkInfo([]);

      // 清除AI解析用的暂存数据
      this.inputTxt = '';
      this.startTxt = '';
      this.checkedTxt = '';
      const requestApis = [null, {
        callApi: generatePoint,
        checkApi: generatePointStatus,
        stopApi: generatePointStop
      }, this.simple ? {
        callApi: generateQuesDirect,
        checkApi: generateQuesStatus,
        stopApi: generateQuesStop
      } : {
        callApi: generateQues,
        checkApi: generateQuesStatus,
        stopApi: generateQuesStop
      }];

      this.callStep = type === 1 ? (this.selectedKngInfo ? 4 : 2) : (2 + requestBody.quesNum / 2);

      // AI对话的会话ID,用于统计当前并发，关闭时需要清理
      if (!this.askIdManage) this.askIdManage = new AIAskIdManager();
      requestBody.sessionId = this.askIdManage.get();

      // 考核点问超过3次时不再走接口
      if (this.askingType === 1 && this.preSaveAskPointCache(requestBody)) {
        requestApis[1] = {
          callApi: this.fakeGeneratePoint,
          checkApi: this.fakeGeneratePointStatus,
          stopApi: undefined
        };
      }

      this.requestClient = loopApiCaller(requestBody, {
        // 处理AI输入文本
        onMsg: data => {
          // 获取时时的信息，提前输出试题或者考核点
          if (this.askingType === 2 && data.quesInfos) {
            this.txtListToQuestion(data.quesInfos);
          } else if (this.askingType === 1 && data.pointContentList) {
            const showPoints = data.pointContentList && data.pointContentList.filter((p) => !!p.point);
            if (!(!data.pointContentList || showPoints.length === 0)) {
              this.pointContentToPoints(requestBody, showPoints, data.contentMap);
            }
          }
        },
        onStatus: (resStatus, taskId) => {
          if (this.askingType === 1) {
            // pointStatus	提取考核点进度状态，0-未开始，2-文件解析开始，4-文件解析完成，6-内容分片开始，8-内容分片完成，10-AI开始提取考核点，12-AI完成提取考核点，14-AI提取考核点失败，16-AI提取考核点取消
            const status = resStatus.pointStatus;
            // 处理文件解析状态，页面会给提示
            if (status === 2) this.parsing = true;
            if (status >= 4) this.parsing = false;
            if (status > 4) this.answering = true;

            if (status === 10) {
              this.requestClient.getMsg(resStatus);
            }

            // 完成
            if (status === 12) {
              this.requestClient.complete(resStatus);
            }

            // 异常情况
            if (status === 14) {
              this.$message({
                message: this.$t(
                  // 'pc_biz_ote_msg_ainotavalid' /** 当前使用人数过多，请稍后再试 */
                  'pc_biz_ote_msg_aiforbidpointinfo' /** 抱歉，无法为您提取考核点，试试换个内容再提取一次 */
                ),
                type: 'error'
              });
              this.cancelAsk();
            }

            if (status === 16) {
              this.cancelAsk();
            }
          } else {
            // AI生成试题进度状态，0-未开始，2-生成中，4-已完成，6-暂停生成，8-生成失败  51-文件解析开始，52-文件解析完成，53-内容分片开始，54-内容分片完成
            const status = resStatus.quesStatus;

            if (status === 51) this.parsing = true;
            else this.parsing = false;

            // 开始时时获取数据
            if (status === 2) {
              this.requestClient.getMsg(resStatus);
            }

            // 完成
            if (status === 4) {
              this.requestClient.complete(resStatus);
            }

            // 异常情况
            if (status === 8) {
              this.$message({
                message: this.$t(
                  // 'pc_biz_ote_msg_ainotavalid' /** 当前使用人数过多，请稍后再试 */
                  'pc_biz_ote_msg_aiforbidinfo' /** 抱歉，无法为您生成试题，试试换个内容再生成一次 */
                ),
                type: 'error'
              });
              this.cancelAsk();
            }

            if (status === 6) {
              this.cancelAsk();
            }
          }
        },
        // 输入完毕
        onEnd: (data) => {
          if (this.askingType === 1) {
            // 过滤空的考点
            const showPoints = data.pointContentList && data.pointContentList.filter((p) => !!p.point);
            if (!data.pointContentList || showPoints.length === 0) {
              this.$message({
                message: this.$t(
                  'pc_biz_ote_msg_aiforbidpointinfo' /** 抱歉，无法为您提取考核点，试试换个内容再提取一次 */
                ),
                type: 'error'
              });
              this.cancelAsk();
              return;
            }

            this.pointContentToPoints(requestBody, showPoints, data.contentMap, () => {
              this.answering = false;
              this.asking = false;
              this.parsing = false;
            });
          } else {
            this.txtListToQuestion(data.quesInfos || [], () => {
              this.asking = false;
              this.parsing = false;
              this.answering = false;
            });
          }
        },
        // 异常
        onError: error => {
          const apiErrorMsg = error && (error.message || (error.error && error.error.message));
          const apiErrorKey = error && (error.key || (error.error && error.error.key));

          if (['apis.core.cap.not.enough', 'apis.aiassist.remain.available.num.not.enough'].includes(apiErrorKey)) {
            // ai 的余额不足
            this.$message({
              message: this.$t('pc_biz_ote_msg_aiquesnobalancetip' /** 剩余可用出题题数不足，请联系管理员 */),
              type: 'info'
            });
            // this.hasAIBalances = false;
          } else if (['apis.aiassist.file.trans.exception'].includes(apiErrorKey)) {
            this.selectedKngInfo.errorInfo = this.$t('pc_biz_ote_msg_aigetfileinfofailed'); // 解析失败，请删除或更换文件
          } else if (['global.param.direction.invalid'].includes(apiErrorKey)) {
            this.$message({
              message: this.$t(
                /** 抱歉，无法为您提取考核点，试试换个内容再提取一次 *//** 抱歉，无法为您生成试题，试试换个内容再生成一次 */
                this.askingType === 1 ? 'pc_biz_ote_msg_aiforbidpointinfo' : 'pc_biz_ote_msg_aiforbidinfo'
              ),
              type: 'error'
            });
          } else if (apiErrorMsg) {
            this.$message({
              message: apiErrorMsg,
              type: 'error'
            });
          } else {
            this.$message({
              message: this.$t(
                'pc_biz_ote_msg_ainotavalid' /** 当前使用人数过多，请稍后再试 */
              ),
              type: 'error'
            });
          }

          this.cancelAsk();
        }
      }, requestApis[type], this.callStep);

      // 记录选择的文件 用于假删恢复
      this.oldSelectedKngLib = this.selectedKngLib;
      this.oldSelectedKng = this.selectedKng;
    },
    // 重新提问某消息
    reAsk(msg) {
      this.$refs.txtAsk.setContent(msg);
    },
    // 终止AI处理
    cancelAsk(confirm) {
      if (confirm) {
        // 停止确认
        this.$confirm(
          this.$t('pc_biz_ote_msg_stopgenquestip' /** 停止生成后，也会进行相应试题数量的扣减，请谨慎操作 */),
          this.$t('pc_biz_ote_msg_surestopgenques' /** 确定要停止生成试题？ */),
          {
            confirmButtonText: this.$t('pc_biz_ote_btn_confirm'),
            cancelButtonText: this.$t('pc_biz_ote_btn_cancle'),
            type: 'warning'
          }
        ).then(() => {
          this.cancelAsk();
        });
        return;
      }

      this.asking = false;
      this.answering = false;
      this.parsing = false;
      // this.askingId = '';
      this.requestClient && this.requestClient.abort && this.requestClient.abort();
      this.itvPoints && clearInterval(this.itvPoints);
      this.outPutItv && clearInterval(this.outPutItv);

      // 出题异常或者取消，还原上次一的状态，如果上一次没有题目就回到出考核点状态
      if (
        this.askingType === 2 &&
        this.currentTalkInfo &&
        this.currentTalkInfo.length <= 1
      ) {
        if (this.beforeTalkInfo && this.beforeTalkInfo[0].askingType === 2) {
          this.currentTalkId = this.beforeTalkInfo[0].talkId;
        } else {
        // 回到考核点的页面
          this.backAsk();
        }
      }

      if (this.askingType === 1 && this.currentTalkPointInfo === null) {
        this.currentTalkPointInfo = this.beforeTalkPointInfo;
      }

    },
    // 多个文本转化为试题
    txtListToQuestion(txts, success) {
      // AI会在最后莫名加一个换行，需要去掉，不然会认为该题已经结束了
      txts && txts.forEach && txts.forEach((txt, index) => {
        txts[index] = txt.replace(/[\r\n]+$/, '');
      });

      // 现在是串行的，可以直接合并处理。（TODO 后面可能多个切片并发处理的情况，数组内容不能合起来处理了，得分开处理。）
      const txtsAll = txts && txts.join && txts.join('\n\n\n\n') || '';
      if (this.resolvedTexts === txtsAll) {
        success && success();
        return;
      }
      this.resolvedTexts = txtsAll;

      const isPre = !success; // 是否预先解析，预先解析时不校验题目完整度，且只输出明确完整的题目
      this.startTxt = '';
      let quesList = [];
      txts.forEach((txt, index) => {
        const analysisData = analysisInputText(txt, index === txts.length - 1 && isPre);
        analysisData.questions.forEach((q) => quesList.push(q));
      });

      // const maxNum = this.oldQuesRequestBody.quesNum;
      // // 排除可能多生成的题目  打乱后取前几个
      // if (quesList.length > maxNum) {
      //   try {
      //     quesList = quesList.sort(() => 0.5 - Math.random()).quesList.filter((q, index) => index < maxNum);
      //   } catch (error) {
      //     quesList = quesList.filter((q, index) => index < maxNum);
      //   }
      // }

      if (quesList.length === 0 && !isPre) {
        this.$message({
          message: this.$t(
            'pc_biz_ote_msg_aiforbidinfo' /** 抱歉，无法为您生成试题，试试换个内容再生成一次 */
          ),
          type: 'error'
        });
        // 回到考核点的页面
        this.cancelAsk();
        return;
      }

      // this.questionsToTalkInfo(quesList);
      // success && success();

      // 这里多道题目加个延迟，让输出更加平滑
      const talkInfo = this.talkInfos[this.askingId];
      let index = (!talkInfo || !talkInfo.length) ? 0 : talkInfo.length - 1;
      const outPutFun = ()=>{
        this.questionsToTalkInfo(quesList.filter((q, i)=> i <= index));
        index++;

        if (index >= quesList.length) {
          clearInterval(this.outPutItv);
          success && success();
        }
      };
      this.outPutItv = setInterval(() => {
        outPutFun();
      }, Math.min((this.callStep - 1) / (quesList.length - index), 1) * 1000);
      outPutFun();
    },
    // 考核点及切片处理成考核点信息
    pointContentToPoints(requestBody, points, contentMap, cb) {
      this.questionsToTalkInfo(undefined, points, contentMap, cb);

      this.currentTalkPointInfo = this.currentTalkInfo[1];
      this.askIndexHistoryIndex = this.currentAskPointsList.length - 1;

      this.saveAskPointCache(requestBody, points, contentMap);
    },
    // 解析拆分AI的对话内容
    questionsToTalkInfo(questions, points, contentMap, cb) {
      // 记录考核点生成历史
      if (!this.talkIndexList[this.askIndex]) {
        this.$set(this.talkIndexList, this.askIndex, []);
      }
      // 初始化对话
      if (!this.talkIdList.find(id => id === this.askingId)) {
        this.talkIdList.push(this.askingId);
        this.$set(this.talkInfos, this.askingId, []);
        this.talkIndexList[this.askIndex].push(this.talkInfos[this.askingId]);
      }
      const talkInfo = this.talkInfos[this.askingId];

      // 提问语
      if (!talkInfo[0]) {
        talkInfo.push({
          type: 0,
          askingType: this.askingType,
          talkId: this.askingId,
          msg: cleanStyle(dealLineFeed(this.askInfoTemp, true)),
          originMsg: this.askInfoTemp,
          points: this.askPointsTemp,
          viewAllAsk: -1
        });

        this.currentTalkId = this.askingId;
      }
      if (questions) {
        // AI回答的的与试题无关的起始语及考核点
        if (!talkInfo[1] && this.startTxt) {
          talkInfo.push({
            type: 11,
            msg: cleanStyle(dealLineFeed(this.startTxt, true))
          });
        }
        // AI回答的试题信息
        const analysedQuesList = getAnalysedQuesList(
          questions,
          this.libId,
          this.libName
        );

        analysedQuesList.forEach((q, index) => {
          // 解析AI的回答后，记录解析好的试题消息
          if (
            !talkInfo[index + this.quesGenedCount + (this.startTxt ? 2 : 1)]
          ) {
            q.talkId = this.askingId;
            talkInfo.push({
              type: 12,
              msg: cleanStyle(dealLineFeed(q.origin._originTxt, true)),
              ques: q
            });
          }
        });
      } else if (points && points.length > 0) {
        let allPoints = talkInfo[1] && talkInfo[1].allPoints || [];
        let addPoints = points.filter(p1 => !allPoints.find(p2 => p2.point === p1.point)); // 新增的考核点
        // 合并同名的
        allPoints.forEach(p1 => {
          let p2 = points.find(p2 => p2.point === p1.point);
          if (p2) p1.contentIds = p2.contentIds;
        });

        // 平滑插入
        let index = 1;
        if (addPoints.length > 0 && this.answering) {
          addPoints[0] && allPoints.push(addPoints[0]);
          this.itvPoints && clearInterval(this.itvPoints);
          this.itvPoints = setInterval(() => {
            if (index >= addPoints.length || !this.answering) {
              clearInterval(this.itvPoints);
              cb && cb();
              return;
            };
            allPoints.push(addPoints[index++]);
          }, Math.min(0.5, (this.callStep - 0.5) / (addPoints.length - 1)) * 1000);
        } else {
          allPoints.push(...addPoints);
          cb && cb();
        }

        const allContentMap = talkInfo[1] && talkInfo[1].contentMap || {};
        Object.assign(allContentMap, contentMap);
        const pointTalkInfo = talkInfo[1] || {
          type: 13,
          talkId: this.askingId,
          askInfo: this.askInfoTemp,
          allPoints: [],
          allContentMap: {},
          checkedPoints: []
        };
        pointTalkInfo.allPoints = allPoints;
        pointTalkInfo.allContentMap = allContentMap;
        pointTalkInfo.checkedPoints = pointTalkInfo.checkedPoints.concat(addPoints.map((p) => p.point));

        talkInfo[1] = pointTalkInfo;
      }
      this.setTalkToEnd();
    },
    preSaveAskPointCache(request) {
      const requestStr = JSON.stringify(request);
      const isChange = this.askPointsCache.askInfo !== requestStr;

      this.askPointsCache.preAsk = true;

      const isOver = !isChange && this.askPointsCache.askPointsCount >= this.maxAskPointCount;
      return isOver;
    },
    // 考核点提取缓存记录
    saveAskPointCache(request, points, contentMap) {
      this.saveAskCount(request);

      if (this.askPointsCache.askPointsCount <= this.maxAskPointCount) {
        this.askPointsCache.points.push(...points);
        Object.assign(this.askPointsCache.contentMap, contentMap);
      }
    },
    // 考核点提取缓存次数记录
    saveAskCount(request) {
      const requestStr = JSON.stringify(request);
      const isChange = this.askPointsCache.askInfo !== requestStr;
      if (isChange) {
        this.askPointsCache = {
          askPointsCount: 1,
          askInfo: requestStr,
          points: [],
          contentMap: {}
        };
      }

      if (this.askPointsCache.preAsk) {
        this.askPointsCache.askPointsCount++;
        this.askPointsCache.preAsk = false;
      }
    },
    // 虚拟出考核点
    fakeGeneratePoint() {
      this.askPointsCache.posting = false;
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            'targetId': '1'
          });
        }, 100);
      });
    },
    // 虚拟出考核点，从缓存拿数据
    fakeGeneratePointStatus() {
      if (!this.askPointsCache.posting) {
        this.askPointsCache.posting = true;
        // 思考中
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve({
              'pointStatus': 10,
              'targetId': '1',
              'pointContentList': [],
              'contentMap': []
            });
          }, 100);
        });
      } else {
        // 抽选缓存的考核点
        const fakePoints = [this.askPointsCache.points[Math.floor(Math.random() * this.askPointsCache.points.length)]];
        this.askPointsCache.points.forEach((p) => {
          // 需要排除重名的
          if (!fakePoints.find(fp => fp.point === p.point) && fakePoints.length < 10 && Math.random() > 0.6) {
            fakePoints.push(p);
          }
        });

        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve({
              'pointStatus': 12,
              'targetId': '1',
              'pointContentList': fakePoints,
              'contentMap': this.askPointsCache.contentMap
            });
          }, 1000);
        });
      }
    },
    // 引用AI出的题目
    useQues(talk) {
      this.$emit('addQues', [talk.ques], success => {
        if (success) {
          talk.used = 1;

          this.$forceUpdate();
        }
      }, 4);
    },
    // 废弃已引用的题目
    deleteQues(ques) {
      const talkQuesList = this.talkInfos[ques.talkId];
      if (talkQuesList) {
        const originTalk = talkQuesList.find(talk => talk.ques === ques);
        if (originTalk) {
          originTalk.used = 0;
        }
      }
      this.$forceUpdate();
    },
    // 删除AI对话内容
    deleteTalk(talkId, index) {
      this.talkInfos[talkId].splice(index, 1);
    },
    // 宽度变化重新判断是否需要展开收起
    setTalkOverLine() {
      this.talkIdList.forEach(id => {
        const talkInfo = this.talkInfos[id];
        const askHtml = this.$refs['ask-' + id];
        if (!talkInfo[0]) return;

        const oldViewAllAsk = talkInfo[0].viewAllAsk;
        if (askHtml && askHtml[0] && askHtml[0].children[0].offsetHeight > 66) {
          talkInfo[0].viewAllAsk = oldViewAllAsk > 0 ? 1 : 0; // 标记为收起状态
        } else {
          talkInfo[0].viewAllAsk = -2; // 不需要展开收起
        }
      });
    },
    // 对话区滚动至底部
    setTalkToEnd() {
      this.$nextTick(() => {
        if (this.$refs.refTalk && this.askingType === 2) {
          const talkScroll = this.$refs.refTalk.$el.children[0];
          talkScroll.scrollTop = talkScroll.scrollHeight;
        }
        if (this.$refs.refPoints && this.askingType === 1) {
          const talkScroll = this.$refs.refPoints.parentElement.parentElement;
          talkScroll.scrollTop = talkScroll.scrollHeight;
        }
      });
    },
    startUpload() {
      this.$refs.uploader && this.$refs.uploader.startUpload();
    },
    uploadedFile(file) {
      this.selectedFile = file;
    },
    getKngFileTypeIcon,
    getKngInfo(info) {
      this.openKngPage = false;
      this.selectedKng = info[0];
    },
    getKngLibInfo(info) {
      this.openKngLibPage = false;
      this.selectedKngLib = this.kngLibsTemp[0];
    },
    closeKngPage() {
      this.openKngPage = false;
    },
    startSelectKng() {
      this.openKngPage = true;
    },
    closeKngLibPage() {
      this.openKngLibPage = false;
    },
    startSelectKngLib() {
      this.kngLibsTemp = [];
      this.openKngLibPage = true;
    },
    clearKngInfo() {
      if (this.currentTalkPointInfo) {
        // 在除了考核点的情况下删除为假删，每次呼出输入框得还原
        this.oldSelectedKngLib = this.selectedKngLib;
        this.oldSelectedKng = this.selectedKng;

        this.selectedKngLib = null;
        this.selectedKng = null;
      } else {
        this.selectedKngLib = null;
        this.selectedKng = null;
      }
    },
    changeSubInput(focus) {
      this.selectedKngLib = this.oldSelectedKngLib;
      this.selectedKng = this.oldSelectedKng;

      this.askInfoEditing = focus;
    },
    cleanPage() {
      this.requestClient && this.requestClient.destroy && this.requestClient.destroy();
      this.cancelAsk();

      this.asking = false;
      this.inputTxt = '';
      this.usedQuesList = [];
      this.talkIdList = [];
      this.talkInfos = {};
      removeResizeListener(this.$refs.talkArea, this.setTalkOverLine);
      this.askIdManage && this.askIdManage.destroy();
    }
  },
  beforeDestroy() {
    this.cleanPage();
  }
};
</script>
